import { memo } from 'react'
import { TopEmployees } from './components/TopEmployee'
import { TopAttendance } from './components/TopAttendance'
import { AverageAgeChart } from './components/chart/TrendAnalysisCategoryChart'
import { TrendAnalysisRevenueBar } from './components/chart/TrendAnalysisRevenueBarChart'
import { FilterReportTrendAnalysisModal } from './components/filter/FilterReportTrendAnalysisModal'
import { useFilterReportTrendAnalysis } from './core/FilterReportTrendAnalysisProvider'
import { JobTitlePieChart } from './components/chart/JobTitlePieChart'
import { ContractTypePieChart } from './components/chart/ContractTypePieChart'

const MemoizeTrendAnalysisRevenue = memo(TrendAnalysisRevenueBar)
const MemoizeTreatmentAnalysisPieChart = memo(JobTitlePieChart)
const MemoizeContractTypePieChart = memo(ContractTypePieChart)

const MemoizeAverageAgeChart = memo(AverageAgeChart)

const DashboardHROverview = () => {
  const { closeModal, showFilterReportTrendAnalysisModal } = useFilterReportTrendAnalysis()

  return (
    <>
      <div className='mt-8 mb-7'>
        <div className='col-md-12 mb-12'>
          <MemoizeTrendAnalysisRevenue />
        </div>
        <div className='row mb-12'>
          <div className='col-md-6'>
            <MemoizeTreatmentAnalysisPieChart
              title='Job Title'
              className='shadow-wit-2 h-100' />
          </div>
          <div className='col-md-6'>
            <MemoizeContractTypePieChart 
            title='Contract Type'
            className='shadow-wit-2 h-100' />
          </div>
        </div>
        <div className='col-md-12 mb-12'>
            <MemoizeAverageAgeChart />
        </div>
        <div className='row mb-12' style={{ height: '559.64px' }}>
          <div className='col-md-6'>
            <TopEmployees className='shadow-wit-2 h-100' />
          </div>
          <div className='col-md-6'>
            <TopAttendance className='shadow-wit-2 h-100' />
          </div>
        </div>
      </div>
      <FilterReportTrendAnalysisModal
        show={showFilterReportTrendAnalysisModal}
        closeModal={() => closeModal()}
      />
    </>
  )
}

export { DashboardHROverview }
